export default __webpack_public_path__ + "e91b2a6ccaf12f190f4dd1c4cc1978e0.png";